const isEnabled = value => value === true || value === '' || value === 'true';

export const HYBRID_SEARCH_GROWTHBOOK_FEATURE = 'hybrid_search_enabled';

export default function resolveHybridSearchEnabled(explicitValue, growthbookValue) {
  if (growthbookValue !== undefined && growthbookValue !== null) {
    return isEnabled(growthbookValue);
  }

  return isEnabled(explicitValue);
}

/**
 * Resolves the hybrid search flag only once it can no longer change.
 * Returns null while GrowthBook is configured but has not evaluated the feature yet,
 * so irreversible work (e.g. deleting recent searches) never runs on the prop fallback.
 */
export function resolveSettledHybridSearchEnabled({
  explicitValue,
  growthbookConfigured,
  growthbookFeatures,
}) {
  const growthbookPending =
    Boolean(growthbookConfigured) &&
    !Object.prototype.hasOwnProperty.call(
      growthbookFeatures || {},
      HYBRID_SEARCH_GROWTHBOOK_FEATURE,
    );

  if (growthbookPending) return null;

  return resolveHybridSearchEnabled(
    explicitValue,
    growthbookFeatures?.[HYBRID_SEARCH_GROWTHBOOK_FEATURE],
  );
}
